import { reactive } from 'vue'

const elementsBoxModel = reactive({})

export default elementsBoxModel